export default __webpack_public_path__ + "static/media/undead-berserker-misprint.d39b4b5f.jpg";